
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.388 16.24a2.715 2.715 0 01-1.704-.635l-3.149-2.773a1.386 1.386 0 00-1.79-.086L.266 16.038v2.138a1.04 1.04 0 001.069 1.098h15.857c.636 0 1.271-.463 1.271-1.098v-5.604l-5.69 3.293a2.628 2.628 0 01-1.386.376zM11.158 10.637a1.271 1.271 0 100-2.541 1.271 1.271 0 000 2.541z","fill":"#C0C2FF"}}),_c('path',{attrs:{"d":"M21.468 2.982a1.069 1.069 0 00-.78-.433L4.946.729A1.329 1.329 0 004.08.96c-.224.195-.377.46-.433.751l-.26 2.253h13.806a2.484 2.484 0 012.427 2.398v10.196c0-.058.26-.116.375-.231a.982.982 0 00.376-.78L21.728 3.82a1.127 1.127 0 00-.26-.838z","fill":"#C0C2FF"}}),_c('path',{attrs:{"d":"M17.194 5.121H1.336c-.635 0-1.068.607-1.068 1.242v8.232l3.812-2.773a2.542 2.542 0 013.206.145l3.178 2.772c.479.407 1.163.465 1.704.145l6.297-3.668V6.363a1.329 1.329 0 00-1.271-1.242zm-6.037 6.672a2.426 2.426 0 110-4.852 2.426 2.426 0 010 4.852z","fill":"#C0C2FF"}})])
          )
        }
      }
    